import styles from './customDivider.module.scss';
import { mesParaAbreviacao } from '../../utils/mesParaAbreviacao';

interface ICustomDividerProps {
  mes?: number;
  ano?: number;
}

function CustomDivider({ mes, ano }: ICustomDividerProps) {
  return (
    <div className={styles.mesAnoContainer}>
      {ano && mes !== undefined && (
        <>
          <span className={styles.text}>Exercício:</span>
          <span className={styles.mesAno}>
            {mesParaAbreviacao(mes ?? parseInt(sessionStorage.getItem('mesDeclaracao') || '-1'))}{' '}
            {ano ?? sessionStorage.getItem('anoDeclaracao')}
          </span>
        </>
      )}
    </div>
  );
}

export default CustomDivider;
